import Button from "../../../components/Button";
import ProgressBar from "../../../components/ProgressBar";
import AddIcon from "/public/images/icons/add.svg?react";
import { useNavigate } from "react-router-dom";
import { useDrawerContext } from "../../../context/drawerContext";
import CloseIcon from "/public/images/icons/close.svg?react";
import TextInput from "../../../components/TextInput";
import { useState } from "react";
import MedicalCard from "../../../components/MedicalCard";
import PropTypes from "prop-types";

export default function Step4({ band, profile, allergies, medications }) {
  const navigate = useNavigate();
  const { setOpen, setDrawerContent } = useDrawerContext();
  const [updatedAllergies, setUpdatedAllergies] = useState(localStorage.getItem("activeBandStep4") ? JSON.parse(localStorage.getItem("activeBandStep4")) : allergies ? allergies : []);
  const [deletedAllergies, setDeletedAllergies] = useState(localStorage.getItem("activeBandStep4Delete") ? JSON.parse(localStorage.getItem("activeBandStep4Delete")) : []);

  const openMedicalDrawer = () => {
    setOpen(true);
    setDrawerContent(
      <div className="w-full">
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">
          ALLERGIES
          </h2>
          <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col justify-stretch">
          <h3 className="text-[24px]">Enter your allergy name</h3>
          <p className="text-sportsDarkGrey mb-[26px]">
            You can update your allergies anytime from your profile page.
          </p>
          <form onSubmit={addAllergies} className="flex flex-col gap-6">
            <TextInput
              key={"allergyName"}
              label={"Allergy Name"}
              name="allergyName"
            />
            <TextInput
              key={"additionalAllergy"}
              label="Additional Information"
              name="additionalInformation"
            />
            <Button submit className="!text-[#101820]">
              Confirm & Continue
            </Button>
          </form>
        </div>
      </div>
    );
  };

  const openEditDrawer = (index) => {
    setOpen(true);
    setDrawerContent(
      <div className="w-full">
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">
          ALLERGIES
          </h2>
          <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col justify-stretch">
          <h3 className="text-[24px]">Edit your allergy</h3>
          <p className="text-sportsDarkGrey mb-[26px]">
            You can update your allergies anytime from your profile page.
          </p>
          <form
            onSubmit={(e) => editAllergies(e, index)}
            className="flex flex-col gap-6"
          >
            <TextInput
              key={"editAllergy" + index}
              defaultValue={updatedAllergies[index].name || updatedAllergies[index].ConditionName}
              label={"Allergy Name"}
              name="allergyName"
            />
            <TextInput
              key={"editAdditional" + index}
              defaultValue={updatedAllergies[index].additionalInformation || updatedAllergies[index].Notes}
              label="Additional Information"
              name="additionalInformation"
            />
            <TextInput
              type="hidden"
              key={"editDateAdded" + index}
              defaultValue={updatedAllergies[index].dateAdded || updatedAllergies[index].DateAdded}
              name="dateAdded"
            />
            <Button submit className="!text-[#101820]">
              Confirm & Continue
            </Button>
          </form>
        </div>
      </div>
    );
  };

  const addAllergies = (event) => {
    event.preventDefault();
    const newDetails = new FormData(event.currentTarget);

    const allergyName = newDetails.get("allergyName")?.trim();
    const additionalInformation = newDetails.get("additionalInformation")?.trim();

    if (!allergyName) {
      return;
    }

    const newMedicalDataArray = [{
      name: allergyName,
      additionalInformation,
      dateAdded: new Date(),
      ongoing: false,
    }];

    setUpdatedAllergies([...updatedAllergies, ...newMedicalDataArray]);
    setOpen(false);
    setDrawerContent(<div></div>);
  };

  const editAllergies = (event, index) => {
    event.preventDefault();

    const newAllergies = updatedAllergies.map((item, i) => {
      if (i === index) {
        item.name = event.currentTarget.allergyName.value;
        item.additionalInformation = event.currentTarget.additionalInformation.value;
        item.dateAdded = event.currentTarget.dateAdded.value;
      }
      return item;
    });
    setUpdatedAllergies(newAllergies);
    setOpen(false);
    setDrawerContent(<div></div>);
  };

  const removeAllergies = (e, index) => {
    e.preventDefault(); // Prevent form submission

    setUpdatedAllergies((prevAllergy) => {
      const allergy = prevAllergy[index];

      if (allergy.AllergyId) {
        setDeletedAllergies((prevDeleted) => {
          // Check if the item already exists in deletedMedicalHistory to avoid adding it twice
          if (!prevDeleted.some(item => item.AllergyId === allergy.AllergyId)) {
            return [...prevDeleted, allergy];
          }
          return prevDeleted;
        });
      }

      return prevAllergy.filter((_, i) => i !== index);
    });
  };

  const checkOngoing = (index) => {
    const newAllergies = updatedAllergies.map((item, i) => {
      if (i === index) {
        item.ongoing = !item.ongoing;
      }
      return item;
    });
    setUpdatedAllergies(newAllergies);
  };

  const validateStep4 = () => {
    localStorage.setItem("activeBandStep4", JSON.stringify(updatedAllergies));
    localStorage.setItem("activeBandStep4Delete", JSON.stringify(deletedAllergies));
    navigate("/add-band/5", { state: { band: band, profile: profile, medications: medications } })
  }

  return (
    <div className="w-full min-h-svh flex flex-col justify-stretch mb-[50px] bg-[#F8F8F8]">
      <div className="p-[24px] flex flex-col gap-6 bg-white">
        <ProgressBar step={4} />
        <span className="tracking-[0.25em] text-[12px] uppercase font-semibold">
          Step 4
        </span>
        <h2>Please let us know of any allergies</h2>
        <p>
          This information will be visible to venue staff and the public when
          your band is unlocked.
        </p>
      </div>
      {updatedAllergies.length > 0 && (
        <div className={`bg-sportsLightGrey border-[#E3E3E3] border-t-[1px] p-[24px] flex justify-center flex-col gap-6 ${updatedAllergies.length <= 1 ?'pb-[250px]' : 'pb-[200px]'}`}>
          {updatedAllergies.map((item, index) => (
            <MedicalCard
              editFunc={() => openEditDrawer(index)}
              checkedFunc={() => checkOngoing(index)}
              removeFunc={(e) => removeAllergies(e, index)}
              key={index}
              medication={item}
              type="allergy"
            />
          ))}
        </div>
      )}
      <div className="border-dashed border-t border-[#E3E3E3]" />
        <div className="fixed bottom-[60px] left-1/2 transform -translate-x-1/2 w-full max-w-[430px] border-t border-l border-r rounded-t-[32px] border-[#E3E3E3] bg-white p-[24px] flex flex-col justify-stretch gap-4">
          <Button className="font-semibold" onClick={openMedicalDrawer} variant="tertiary">
            <AddIcon className="w-[15px]" />
            Add Allergy
          </Button>
          <Button
            onClick={validateStep4}
          >
            {updatedAllergies.length > 0
              ? "Confirm & Continue"
              : "Continue Without Allergies"}
          </Button>
        </div>
    </div>
  );
}

Step4.propTypes = {
  band: PropTypes.object,
};